import { i18, trb } from 'src/Utilities';
import { Tabs } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { routerPath } from 'src/Config';
import { matchPath, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'src/Components';
import { UnsignedPaymentFileDetails } from './UnsignedPaymentFileDetails';
import { UnsignedPaymentsWrapper } from './UnsignedPaymentsWrapper';
import { UnsignedPaymentFilesWrapper } from './UnsignedPaymentFilesWrapper';

export const UnsignedPaymentsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const matchUnsigned = matchPath(
    {
      path: `${routerPath.payments}/${routerPath.unsigned}`,
    },
    location.pathname
  );

  const matchFiles = matchPath(
    {
      path: `${routerPath.payments}/${routerPath.unsigned}/${routerPath.unsignedFiles}`,
    },
    location.pathname
  );

  const matchDetails = matchPath(
    {
      path: `${routerPath.payments}/${routerPath.unsigned}/${routerPath.unsignedFiles}/${routerPath.unsignedFileDetails}`,
    },
    location.pathname
  );

  const items = [
    (matchUnsigned !== null || matchFiles !== null) && { label: trb(i18.ContentTitles.UnsignedPayments), key: `${routerPath.payments}/${routerPath.unsigned}` },
    (matchUnsigned !== null || matchFiles !== null) && {
      label: trb(i18.ContentTitles.UnsignedPaymentFiles),
      key: `${routerPath.payments}/${routerPath.unsigned}/${routerPath.unsignedFiles}`,
    },
    matchDetails !== null && {
      label: (
        <div className="back-button-link">
          <LeftOutlined
            className="mr-0"
            aria-hidden="true"
          />
          <div>{trb(i18.Labels.Back)}</div>
        </div>
      ),
      key: routerPath.unsignedFiles,
    },
  ];

  return (
    <Container>
      <Tabs
        id="UnsignedPaymentsContainerTabs"
        defaultActiveKey={location.pathname}
        className="mt--3 mb-3"
        activeKey={location.pathname}
        items={items
          .filter((e) => !!e)
          .map((item) => ({
            ...item,
            label: <div className="text-black-70">{item.label}</div>,
            key: item.key,
          }))}
        onTabClick={(key) => navigate(key)}
      />
      <Routes>
        <Route
          path={routerPath.unsignedFiles + '/*'}
          element={
            <Routes>
              <Route
                path={routerPath.unsignedFileDetails}
                element={<UnsignedPaymentFileDetails />}
              />
              <Route
                index={true}
                element={<UnsignedPaymentFilesWrapper />}
              />
            </Routes>
          }
        />
        <Route
          index={true}
          element={<UnsignedPaymentsWrapper />}
        />
      </Routes>
    </Container>
  );
};
